import { Injectable } from '@angular/core';
import { HttpService } from '@docpath/linces-angular-components/common';
import { Observable } from 'rxjs';
import { EndPoints } from 'src/app/constants/end-points';

import { SelfMaintenance } from '../models/self-maintenance';

@Injectable({
    providedIn: 'root'
})
export class SelfMaintenanceHttpService {

    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_CONFIGURATION}/${EndPoints.ENDPOINT_CONFIGURATION_SELF_MAINTENANCE}`;

    constructor(
        private readonly httpService: HttpService
    ) { }

    getSelfMaintenanceConfig(): Observable<SelfMaintenance> {
        return new Observable(observer => {
            this.httpService.get({
                relativeUrl: this.relativeUrl,
                loading: true,
                suscribe: response => {
                    const config = response.result as unknown as SelfMaintenance;
                    observer.next(config);
                    observer.complete();
                }
            });
        });

    }

    updateSelfMaintenanceConfig(config: SelfMaintenance): Observable<void> {
        return new Observable(observer => {
            this.httpService.put(config, {
                relativeUrl: this.relativeUrl,
                loading: true,
                suscribe: () => {
                    observer.next();
                    observer.complete();
                },
                toast: 'self-maintenance.toast.success'
            });
        });
    }
}
